import { FormFieldGroupContainer } from '../FormFieldGroupContainer';
import { DynamicFormField } from '../formFields/DynamicFormField';

export const FormFields = ({ fieldDefs, container }) => {
  if (!fieldDefs) return;

  const ContainerComponent = container ?? FormFieldGroupContainer;
  return (
    <ContainerComponent>
      {fieldDefs.map((fieldDef) => {
        if (fieldDef.hide) return null;
        return fieldDef.component ?? <DynamicFormField key={fieldDef.field} fieldDef={fieldDef} />;
      })}
    </ContainerComponent>
  );
};
